var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "pvtnCard", attrs: { shadow: "hover" } },
    [
      _c(
        "el-row",
        { staticClass: "center" },
        [
          _c(
            "el-col",
            { staticClass: "flex", attrs: { span: 10 } },
            [
              _c("span", [_vm._v("Início de vigência:")]),
              _c("el-date-picker", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "##/##/#####",
                    expression: "'##/##/#####'"
                  }
                ],
                attrs: {
                  format: "dd/MM/yyyy",
                  "value-format": "yyyy-MM-dd",
                  placeholder: "Selecione",
                  type: "date",
                  disabled: _vm.isVisualizar
                },
                model: {
                  value: _vm.pvtn.inicio,
                  callback: function($$v) {
                    _vm.$set(_vm.pvtn, "inicio", $$v)
                  },
                  expression: "pvtn.inicio"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { staticClass: "flex", attrs: { span: 10 } },
            [
              _c("span", [_vm._v("Final de vigência:")]),
              _c("el-date-picker", {
                directives: [
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: "##/##/#####",
                    expression: "'##/##/#####'"
                  }
                ],
                attrs: {
                  format: "dd/MM/yyyy",
                  "value-format": "yyyy-MM-dd",
                  placeholder: "Selecione",
                  type: "date",
                  disabled: _vm.isVisualizar
                },
                model: {
                  value: _vm.pvtn.fim,
                  callback: function($$v) {
                    _vm.$set(_vm.pvtn, "fim", $$v)
                  },
                  expression: "pvtn.fim"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-492c7e0b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-492c7e0b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/vtn/components/PvtnVigenciaCard.vue
// module id = null
// module chunks = 